import React from "react";
import { LinkIcon } from "@heroicons/react/24/outline";

function LinksManagement() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Link Yönetimi</h1>
        <p className="text-gray-600">Tüm sistem linklerini yönetin</p>
      </div>

      <div className="card">
        <div className="card-body text-center py-12">
          <LinkIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Link Yönetimi Geliştiriliyor
          </h3>
          <p className="text-gray-600">Bu sayfa geliştirilme aşamasındadır</p>
        </div>
      </div>
    </div>
  );
}

export default LinksManagement;
